<script>
  import { Tooltip } from "paxray-components-svelte";

  export let header = "";
  export let showLeftIndicator = false;
  export let indicatorColor = "";
  export let tooltipText = "";
  export let rightIndicatorValue = "";
</script>

<header
  class="seamless_grid_header"
  style={indicatorColor ? `--indicator-color: ${indicatorColor};` : ""}
>
  <div class="seamless_grid_header_title">
    {#if showLeftIndicator}
      <span class="seamless_grid_header_indicator" aria-hidden="true" />
    {/if}
    <span class="seamless_grid_header_text">{header}</span>
    {#if tooltipText}
      <Tooltip text={tooltipText} />
    {/if}
  </div>

  {#if rightIndicatorValue !== "" && rightIndicatorValue !== null}
    <span class="seamless_grid_header_value">{rightIndicatorValue}</span>
  {/if}
</header>

<style>
  .seamless_grid_header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: var(--app-header-height);
    box-sizing: border-box;
    gap: 1rem;
    padding: 0 1rem;
    background: var(--pax-white, #fff);
    border-bottom: 1px solid var(--border-color);
  }

  .seamless_grid_header_title {
    display: flex;
    align-items: center;
    min-width: 0;
    gap: 0.5rem;
  }

  .seamless_grid_header_indicator {
    width: 0.75rem;
    height: 0.75rem;
    flex: 0 0 0.75rem;
    border-radius: 0.1875rem;
    background: var(--indicator-color, var(--pax-yellow-new));
  }

  .seamless_grid_header_text {
    overflow: hidden;
    color: var(--pax-black, #1c1c20);
    font-family: var(--font-family, Inter), sans-serif;
    font-size: 0.875rem;
    font-weight: 700;
    line-height: 1.2;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .seamless_grid_header_value {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 1.625rem;
    height: 1.625rem;
    flex-shrink: 0;
    padding: 0 0.45rem;
    box-sizing: border-box;
    border-radius: 50%;
    background: color-mix(
      in srgb,
      var(--indicator-color, var(--pax-yellow-new)) 35%,
      white
    );
    color: var(--pax-black, #1c1c20);
    font-family: var(--font-family, Inter), sans-serif;
    font-size: 0.8125rem;
    font-weight: 700;
    line-height: 1;
  }
</style>
